import apiSlice from "./ApiSlice";

const franchiseApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // get all delivery dates
        getAllFranchiseData: builder.query({
            providesTags: ["franchise"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/franchise",
                    method: "POST",
                    body,
                };
            },
        }),
        getAllFranchiseExcelData: builder.mutation({
            // invalidatesTags: ["franchise"],
            query: (body: PaginationPayloadType) => {
                return {
                    url: "/franchise",
                    method: "POST",
                    body,
                };
            },
        }),

        // delete delivery date
        deleteFranchiseById: builder.mutation({
            invalidatesTags: ["franchise"],
            query: (id: any) => ({
                url: `/franchise/${id}`,
                method: "DELETE",
            }),
        }),
        // add delivery date
        addFranchise: builder.mutation({
            invalidatesTags: ["franchise"],
            query: (body) => ({
                url: `/franchise/add`,
                method: "POST",
                body,
            }),
        }),
        //get delivery date by Id
        getFranchiseById: builder.query({
            providesTags: ["franchise"],
            query: (id: string) => {
                return {
                    url: `/franchise/${id}`,
                    method: "GET",
                };
            },
        }),

        // update delivery date
        updateFranchiseById: builder.mutation({
            invalidatesTags: ["franchise"],
            query: ({ body, id }) => ({
                url: `/franchise/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // change status of delivery date
        changeStatusFranchiseById: builder.mutation({
            invalidatesTags: ["franchise"],
            query: ({ body, id }) => ({
                url: `/franchise/status-change/${id}`,
                method: "PUT",
                body,
            }),
        }),
        //get all modes
        getAllFranchise: builder.query({
            providesTags: ["franchise"],
            query: () => {
                return {
                    url: `/franchise`,
                    method: "GET",
                };
            },
        }),
    }),
});

export const {
    useGetAllFranchiseDataQuery,
    useDeleteFranchiseByIdMutation,
    useAddFranchiseMutation,
    useGetFranchiseByIdQuery,
    useUpdateFranchiseByIdMutation,
    useChangeStatusFranchiseByIdMutation,
    useGetAllFranchiseQuery,
    useGetAllFranchiseExcelDataMutation
} = franchiseApi;
